import { render } from "./company-list.vue?vue&type=template&id=440ad4e3&scoped=true"
import script from "./company-list.vue?vue&type=script&lang=js"
export * from "./company-list.vue?vue&type=script&lang=js"

import "./company-list.vue?vue&type=style&index=0&id=440ad4e3&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440ad4e3"]])

export default __exports__